import React from 'react'

class DashRow extends React.Component {

    render() {
        return (
            <div className={this.props.size}>
                <div className="card-body pinned-row text-center">
                    <p className="mb-2 mt-1 text-muted">{this.props.title}</p>
                    <h3 className="mb-1 mt-1 number-font counter">{this.props.value}</h3>
                    <p className="mb-2 text-muted">
                        <span className={this.props.color}>
                            <i className={this.props.icon}></i>
                            {this.props.percentage}
                        </span> 
                        <span className="d-inline-block text-truncate" style={{maxWidth:"100px"}}>{this.props.caption}</span>
                    </p>
                </div>
            </div>
        )
    }

}

export default DashRow